// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"02f418c9","332":"3b24a0a1","453":"d855a71b","485":"d97c4317","510":"63d488a1","673":"cd29b7fa","675":"a645f6f1","725":"0c6ac171","875":"30312c7f","908":"9e3de99d"}[chunkId] + ".chunk.js";
};